<template>
  <div class="box auth register">
    <div class="message">
      <h2 style="text-align: center">{{ $t('auth.verifyheading')}}</h2>

      <div style="text-align: center" class="success-msg">
        <p>{{ $t('auth.verifymessage')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import mixins from '../mixins'

export default {
  name: 'Verify',

  mixins: [mixins],

  methods: {
    ...mapActions('user', ['verify'])
  },

  mounted: function () {
    this.verify({ 'token': this.$route.query.token }).then(() => {
      this.$router.push('/login')
    })
  }
}
</script>
